// extracted by mini-css-extract-plugin
module.exports = {"hidden":"gameNotice_hidden__ec0zH","textEmphasis":"gameNotice_textEmphasis__Emhyw","noticeText":"gameNotice_noticeText__28Les"};